module.exports = "https://r.nearpod.com/assets/media/image/add-to-4d45874d20ac9e603734e4d846890c6e.svg";